// src/firebase/config.js
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
const firebaseConfig = {
  apiKey: "AIzaSyDuvA6OU_Zy29kF2nDrutkDpaFun9rdDqU",
  authDomain: "be-car-check.firebaseapp.com",
  projectId: "be-car-check",
  storageBucket: "be-car-check.firebasestorage.app",
  messagingSenderId: "324674561731",
  appId: "1:324674561731:web:5c9b931b10b8c111862476",
  measurementId: "G-KMKQ3V6QW7"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Initialize Cloud Firestore and get a reference to the service
export const db = getFirestore(app);

export default app;